const es = {
	nav: {
		home: 'Inicio',
		about: 'Acerca de mí',
		work: 'Mis Proyectos',
		contact: 'Contactame'
	},
	contactModal: {
		title: 'Contactame',
		sendEmail: 'Enviar correo',
		chatWhatsApp: 'Chatear por WhatsApp',
		visitVantech: 'Ir a Vantech'
	},
	home: {
		profileAlt: 'Perfil',
		videoAlt: 'Video transparente',
		techPartners: 'Socios tecnológicos',
		roles: [
			'Diseñador Web',
			'Pensador Creativo',
			'Entusiasta de UI/UX',
			'Desarrollador Front-End'
		]
	},
	about: {
		greeting: 'Hola, soy Rodrigo',
		paragraph1:
			'Soy {webDesigner} y {uxSpecialist} con más de 4 años de experiencia profesional. Estudié ingeniería en sistemas en la Universidad ITESO en la ciudad de Guadalajara, México.',
		webDesigner: 'diseñador web',
		uxSpecialist: 'especialista en UI/UX',
		paragraph2:
			'Actualmente trabajo para {breken} y para {vantech}. Siempre estoy buscando nuevos proyectos para {colaborar} y {aprender} cosas nuevas.',
		breken: 'Breken',
		vantech: 'Vantech',
		colaborar: 'colaborar',
		aprender: 'aprender',
		paragraph3:
			'Me apasiona {disenar} y {desarrollar} los {suenos} de mis clientes, siempre buscando la {mejorExperiencia} de usuario y la {mejorCalidad} en el código.',
		disenar: 'diseñar',
		desarrollar: 'desarrollar',
		suenos: 'sueños',
		mejorExperiencia: 'mejor experiencia',
		mejorCalidad: 'mejor calidad',
		paragraph4: 'Descubre más sobre mi trabajo viendo mis {proyectos}',
		proyectos: 'proyectos',
		downloadCV: 'Descargar CV',
		photoAlt: 'Rodrigo Alvarez'
	},
	work: {
		filters: {
			all: 'Todos',
			commercial: 'Comerciales',
			learning: 'Aprendizaje'
		},
		sectionTitle: 'Mis Proyectos'
	},
	footer: {
		tagline: 'Diseñador Web & Especialista UI/UX',
		navigation: 'Navegación',
		home: 'Inicio',
		about: 'Acerca de mí',
		work: 'Proyectos',
		contact: 'Contacto',
		copyright: 'Todos los derechos reservados.'
	},
	sidebar: {
		ariaLabel: 'Navegación de secciones',
		sections: {
			home: 'Inicio',
			about: 'Acerca de mí',
			work: 'Mis Proyectos'
		}
	},
	loading: {
		ariaLabel: 'Cargando portafolio',
		tagline: 'Portafolio'
	},
	projectCard: {
		learningBadge: 'Aprendizaje',
		confidential: 'Proyecto Confidencial',
		underConstruction: 'En construcción'
	},
	projectModal: {
		closeLabel: 'Cerrar',
		confidential: 'Proyecto Confidencial',
		confidentialDesc:
			'Este proyecto no puede ser mostrado debido a acuerdos de confidencialidad.',
		learningBadge: 'Aprendizaje',
		descriptionTitle: 'Descripción del proyecto',
		gallery: 'Galería',
		viewGitHub: 'Ver en GitHub',
		viewLive: 'Ver proyecto en vivo'
	},
	projects: {
		breken: {
			description:
				'Sistema logístico para rastreo de camiones de carga y descarga de productos Nacionales.',
			date: 'Marzo 2023 - Presente',
			extendedDescription:
				'Breken es un sistema logístico completo que integra administración, operación y seguimiento en una sola plataforma. Permite automatizar procesos logísticos, gestionar viajes y facturación y monitoreo de unidades en tiempo real mediante su app.\n\nEn este proyecto pude participar desde su diseño, desarrollo y mantenimiento actualmente. Principalmente en el desarrollo de la interfaz de usuario y la integración de la app con el sistema. Breken cuenta con un sistema que permite el manejo completo desde la nube.\n\nRol en el proyecto: Diseño y desarrollo de interfaz web y móvil, integración de la app con el sistema, desarrollo de funcionalidades y mantenimiento del sistema.'
		},
		sistemaPacientes: {
			description:
				'Sistema interno de gestión de pacientes diseñado y desarrollado por Vantech.',
			date: 'Septiembre 2025 - Febrero 2026',
			extendedDescription:
				'Sistema interno de gestión de pacientes diseñado y desarrollado por Vantech para agilizar el registro de pacientes, consultas, pagos y prescripciones en múltiples ubicaciones, con sincronización en tiempo real y soporte para sesiones de alta demanda.\n\nEl sistema está construido con React, Tailwind CSS, AWS y PostgreSQL. El sistema permite a los usuarios registrar pacientes, agendar consultas, realizar pagos y prescripciones, y ver el historial de pacientes.\n\nRol en el proyecto:\n\nDiseño y desarrollo de la interfaz de usuario, integración del servidor con el sistema, desarrollo de funcionalidades y mantenimiento del sistema.'
		},
		miel: {
			description:
				'Página web para Miel de la Cruz, una empresa de venta de miel con causa.',
			date: 'Febrero 2026 - Marzo 2026',
			extendedDescription:
				'Miel de la Cruz es una empresa dedicada a la producción y venta de miel pura y productos relacionados como propóleos, granola, siropes naturales y cuidado personal. La plataforma web cuenta con una tienda en línea, presentaciones de productos, información sobre sostenibilidad y una sección de experiencias, todas diseñadas para resaltar la calidad y origen natural de sus productos de Aguascalientes, México.\n\nPase del diseño al desarrollo pixel perfect de la plataforma elegante y profesional con secciones de tienda, blogs y contacto. Implementé efectos de cursor personalizados y optimización de rendimiento para una experiencia de usuario fluida.'
		},
		jowibay: {
			description: 'Aplicación móvil de catálogo de productos agrícolas.',
			date: 'Octubre 2024 - Abril 2025',
			extendedDescription:
				'JowiBay es una aplicación móvil diseñada para conectar productores agrícolas con compradores de forma directa, funcionando como un catálogo digital donde los proveedores pueden mostrar sus productos y los compradores pueden descubrir nuevas opciones de abastecimiento.\n\nEn este proyecto participé principalmente en el diseño y desarrollo de la interfaz de usuario, enfocándome en crear una experiencia clara, funcional y accesible para ambos tipos de usuarios: productores y compradores. La app fue diseñada para facilitar la navegación por el catálogo, la visualización de productos y la comunicación directa entre las partes interesadas.\n\nLa plataforma está construida con Supabase, utilizado para la gestión de datos, autenticación y estructura backend. Además, la aplicación cuenta con un sistema de suscripciones dentro de la app, permitiendo a los usuarios acceder a funcionalidades o beneficios según el tipo de plan contratado.\n\nUno de los elementos principales de JowiBay es su sistema de chat integrado, que permite que proveedores y compradores se comuniquen directamente dentro de la aplicación. Sin embargo, la app no procesa pagos ni transacciones entre usuarios; su objetivo principal es servir como un punto de contacto y exposición comercial, funcionando como un catálogo interactivo para el sector agrícola.\n\nDesde el enfoque de UI, el trabajo se centró en diseñar pantallas limpias, intuitivas y fáciles de usar, priorizando la presentación visual de los productos, la organización de la información y una navegación fluida. Se buscó que la interfaz transmitiera confianza, simplicidad y utilidad, adaptándose a las necesidades de usuarios que buscan vender o encontrar productos agrícolas de manera rápida y directa.\n\nRol en el proyecto:\n\nDiseño y desarrollo de interfaz móvil, experiencia de usuario, diseño de pantallas principales, navegación, catálogo de productos, interfaz de chat y flujos relacionados con suscripciones dentro de la app.'
		},
		kibox: {
			description:
				'Rediseño de la página web de Kibox, una empresa de venta de cartones.',
			date: 'Noviembre 2023 - Diciembre 2023',
			extendedDescription:
				'Kibox es una empresa que se dedica a la venta de cartones de alta calidad. Con el equipo de Vantech ® llevamos a cabo un rediseño completo de la página web de Kibox para mejorar la representación de sus productos de lujo con un nuevo logotipo, colores frescos y tipografía actualizada. También nos encargamos de reorganizar los diseños de productos y presentaciones para hacer todo claro y atractivo.\n\nRol en el proyecto:\n\nDiseño y desarrollo de la página web, rebranding, reorganización de productos y presentaciones.'
		},
		aires: {
			description:
				'Sistema de gestión de viajes para la empresa Aires Operadora.',
			date: 'Septiembre 2023 - Diciembre 2023',
			extendedDescription:
				'Aires Operadora es una agencia de viajes y turismo. No solamente venden viajes, sino que te venden experiencias completas, eso es lo que quisimos reflejar en el rediseño de su página web.\n\nRol en el proyecto:\n\nDiseño y desarrollo de la página web, rebranding.'
		},
		vantech: {
			description:
				'Página web para la empresa Vantech, empresa de desarrollo de software.',
			date: 'Agosto 2023 - Noviembre 2023',
			extendedDescription:
				'En Vantech nos encargamos de hacer que tus sueños se hagan realidad. Desde la concepción hasta la implementación, nos encargamos de que tu proyecto sea un éxito.\n\nCualquier solución tecnológica, desde la web hasta la app, nosotros la hacemos realidad.\n\nRol en el proyecto:\n\nDiseño y desarrollo de la página web, rebranding.'
		},
		spgps: {
			description: 'Página web para la empresa Sp GPS.',
			date: 'Julio 2023 - Octubre 2023',
			extendedDescription:
				'SP GPS es una empresa que se dedica a la venta de GPS y equipos de navegación. Con el equipo de Vantech ® llevamos a cabo un rediseño completo de la página web de SP GPS para mejorar la representación de sus productos y servicios.\n\nRol en el proyecto:\n\nDiseño y desarrollo de la página web, rebranding.'
		},
		brekenmx: {
			description: 'Página web para la empresa Breken.',
			date: 'Abril 2023 - Agosto 2023',
			extendedDescription:
				'Breken.mx es la página comercial del software Breken, una plataforma de gestión de viajes y logística.\n\nPara este sitio web realicé el diseño y desarrollo de la página web, con un enfoque en la usabilidad y la experiencia del usuario.\n\nRol en el proyecto:\n\nDiseño y desarrollo de la página web.'
		},
		inco: {
			description: 'Página web para la empresa Inco.',
			date: 'Febrero 2023 - Mayo 2023',
			extendedDescription:
				'Inco es la empresa de logística que se encargó del desarrollo de Breken, software de gestión de viajes y logística.\n\nPara este sitio web realicé el diseño y desarrollo de la página web, con un enfoque en la usabilidad y la experiencia del usuario.\n\nRol en el proyecto:\n\nDiseño y desarrollo de la página web.'
		},
		fitroutine: {
			description:
				'FitRoutine es una aplicación web mobile-first para crear, gestionar y seguir rutinas de entrenamiento.',
			date: 'Junio 2026 - Presente',
			extendedDescription:
				'FitRoutine es una aplicación fullstack local-first diseñada para que los usuarios creen, organicen y rastreen sus rutinas de entrenamiento desde cualquier dispositivo dentro de la misma red.\n\nEl frontend está construido con React 19 y TypeScript, utilizando Vite como herramienta de construcción y React Router para la navegación. La interfaz sigue un enfoque mobile-first con CSS Modules, soportando tres temas visuales (oscuro, claro, sunset) y dos idiomas (inglés, español) mediante un sistema de i18n basado en contextos personalizados.\n\nEl backend utiliza Node.js con Express 5 y TypeScript, siguiendo una arquitectura por capas (routes → controllers → services → database). La persistencia de datos está manejada por Prisma ORM con SQLite, manteniendo todos los datos de forma local sin requerir servicios externos ni infraestructura en la nube.\n\nEntre sus funcionalidades destacan una biblioteca completa de ejercicios con categorización por grupo muscular y equipamiento, un constructor de rutinas con reordenamiento drag-and-drop, seguimiento en tiempo real de sesiones de entrenamiento con marcado de series, historial de entrenamientos con resúmenes diarios, y generación de códigos QR para acceso instantáneo desde el celular.\n\nRol en el proyecto:\n\nDiseño de API RESTful, gestión de esquemas de base de datos con migraciones, interfaz responsiva, manejo de estado y sincronización entre dispositivos sobre una red local.'
		}
	},
	skills: {
		softSkills: {
			teamwork: {
				skill: 'Trabajo en equipo',
				description:
					'Capacidad para colaborar efectivamente con otros miembros del equipo, compartiendo conocimientos y trabajando hacia objetivos comunes.'
			},
			communication: {
				skill: 'Comunicación efectiva',
				description:
					'Habilidad para transmitir ideas de manera clara y concisa, tanto de forma verbal como escrita, adaptando el mensaje según la audiencia.'
			},
			adaptability: {
				skill: 'Adaptabilidad',
				description:
					'Capacidad para ajustarse rápidamente a nuevos entornos, tecnologías y metodologías, manteniendo un alto nivel de productividad.'
			},
			problemSolving: {
				skill: 'Resolución de problemas',
				description:
					'Habilidad para analizar situaciones complejas, identificar problemas y desarrollar soluciones efectivas y creativas.'
			},
			learningAbility: {
				skill: 'Capacidad de aprendizaje',
				description:
					'Disposición y habilidad para adquirir nuevos conocimientos y habilidades de manera continua, manteniéndose actualizado en el campo.'
			}
		}
	}
}

export default es
